import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getConclusieItems, createConclusieItem, updateConclusieItem, deleteConclusieItem } from "../Reducers/actions";
import Modal from "../../../Components/Modal/Modal";

const ConclusieItemsPage = () => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    text: "",
    beschrijving: "",
    tag: "",
    certificaat_uitgeven: false
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getConclusieItems());
      setItems(response.results || []);
    } catch (error) {
      console.error("Error loading conclusie items:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setFormData({
        text: item.text,
        beschrijving: item.beschrijving || "",
        tag: item.tag || "",
        certificaat_uitgeven: item.certificaat_uitgeven || false
      });
    } else {
      setEditingItem(null);
      setFormData({
        text: "",
        beschrijving: "",
        tag: "",
        certificaat_uitgeven: false
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingItem(null);
    setFormData({
      text: "",
      beschrijving: "",
      tag: "",
      certificaat_uitgeven: false
    });
  };

  const handleSave = async () => {
    if (!formData.text.trim()) {
      alert("Vul de conclusietekst in");
      return;
    }

    setSaving(true);
    try {
      if (editingItem) {
        await dispatch(updateConclusieItem(editingItem._id, formData));
      } else {
        await dispatch(createConclusieItem(formData));
      }
      handleCloseModal();
      loadItems();
    } catch (error) {
      console.error("Error saving conclusie item:", error);
      alert("Fout bij opslaan");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Weet je zeker dat je deze conclusie wilt verwijderen?")) {
      return;
    }

    try {
      await dispatch(deleteConclusieItem(id));
      loadItems();
    } catch (error) {
      console.error("Error deleting conclusie item:", error);
      alert("Fout bij verwijderen");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3>Conclusies</h3>
              <button
                className="btn btn-primary"
                onClick={() => handleOpenModal()}
              >
                <i className="fas fa-plus mr-2"></i>
                Nieuwe Conclusie
              </button>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Laden...</span>
                  </div>
                </div>
              ) : items.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-gavel fa-3x text-muted mb-3"></i>
                  <p className="text-muted">Nog geen conclusies aangemaakt</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => handleOpenModal()}
                  >
                    Maak je eerste conclusie
                  </button>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Conclusietekst</th>
                        <th style={{width: '200px'}}>Beschrijving</th>
                        <th style={{width: '150px'}}>Tag</th>
                        <th style={{width: '130px'}}>Certificaat</th>
                        <th style={{width: '150px'}}>Acties</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item) => (
                        <tr key={item._id}>
                          <td>
                            <span style={{whiteSpace: 'pre-wrap'}}>{item.text}</span>
                          </td>
                          <td>
                            <span className="text-muted">{item.beschrijving || '-'}</span>
                          </td>
                          <td>
                            {item.tag ? (
                              <span className="badge badge-info">{item.tag}</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {item.certificaat_uitgeven ? (
                              <span className="badge badge-success">
                                <i className="fas fa-check mr-1"></i>
                                Ja
                              </span>
                            ) : (
                              <span className="badge badge-secondary">
                                Nee
                              </span>
                            )}
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-primary mr-2"
                              onClick={() => handleOpenModal(item)}
                              title="Bewerken"
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDelete(item._id)}
                              title="Verwijderen"
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal voor toevoegen/bewerken */}
      <Modal
        visible={showModal}
        onClose={handleCloseModal}
        width={700}
        className="conclusie-modal"
      >
        <div className="p-4">
          <h4 className="mb-4">
            {editingItem ? "Conclusie Bewerken" : "Nieuwe Conclusie"}
          </h4>

          <div className="form-group">
            <label><strong>Conclusietekst *</strong></label>
            <textarea
              className="form-control"
              rows={4}
              placeholder="Bijv. Er zijn geen afwijkingen geconstateerd, het certificaat wordt verstrekt..."
              value={formData.text}
              onChange={(e) => setFormData({ ...formData, text: e.target.value })}
            />
            <small className="text-muted">
              Gebruik <code>{'{{inspectiedatum}}'}</code> om de inspectiedatum in te voegen in de tekst.
            </small>
          </div>

          <div className="form-group">
            <label><strong>Korte beschrijving</strong></label>
            <input
              type="text"
              className="form-control"
              placeholder="Bijv. Geen afwijkingen, Afwijkingen geconstateerd..."
              value={formData.beschrijving}
              onChange={(e) => setFormData({ ...formData, beschrijving: e.target.value })}
            />
            <small className="text-muted">
              Korte samenvatting van de conclusie, wordt getoond bij het selecteren van conclusies.
            </small>
          </div>

          <div className="form-group">
            <label><strong>Tag</strong></label>
            <input
              type="text"
              className="form-control"
              placeholder="Bijv. Waterglijbaan, Speeltoestel, Zwembad..."
              value={formData.tag}
              onChange={(e) => setFormData({ ...formData, tag: e.target.value })}
            />
            <small className="text-muted">
              Categoriseer de conclusie zodat je snel kunt filteren bij het selecteren.
            </small>
          </div>

          <div className="form-group">
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id="certificaatUitgeven"
                checked={formData.certificaat_uitgeven}
                onChange={(e) => setFormData({ ...formData, certificaat_uitgeven: e.target.checked })}
              />
              <label className="custom-control-label" htmlFor="certificaatUitgeven">
                <strong>Certificaat kan worden uitgegeven</strong>
                <br />
                <small className="text-muted">Bij deze conclusie kan een certificaat worden verstrekt</small>
              </label>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              className="btn btn-secondary mr-2"
              onClick={handleCloseModal}
            >
              Annuleren
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2"></span>
                  Opslaan...
                </>
              ) : (
                <>
                  <i className="fas fa-save mr-2"></i>
                  Opslaan
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConclusieItemsPage;
